import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgForm } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { SignUpUser } from '../../classes/sign-up-user';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reset-password-page',
  templateUrl: './reset-password-page.component.html',
  styleUrls: ['./reset-password-page.component.scss']
})
export class ResetPasswordPageComponent implements OnInit {
  passwordFocus: boolean = false;
  confirmPasswordFocus: boolean = false;
  phoneFocus: boolean = false;
  resetting: boolean = false;
  msgs: string[] = [];
  user: SignUpUser = <SignUpUser>{};
  sub: any;
  confirmationToken: string;

  constructor(
    private UserService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.titleService.setTitle('Reset Password');
    this.sub = this.route.queryParams.subscribe(params => {
      this.confirmationToken = params['confirmation_token'];
    })
  }

  resetPassword(resetForm: NgForm) {
    this.resetting = true;
    this.msgs = [];
    if (resetForm.invalid || (this.user.password != this.user.password_confirmation)) {
      return;
    }

    let data: any = {
      user: {
        password: this.user.password,
        password_confirmation: this.user.password_confirmation,
        reset_password_token: this.confirmationToken,
        phone_number: this.user.phone_number
      }
    };
    this.UserService.resetPassword(data)
      .subscribe(res => {
        this.router.navigate(['/', 4]);
      }, err => {
        this.msgs.push(JSON.parse(JSON.parse(err._body).flash)[0][1]);
      })

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/reset-password-page/reset-password-page.component.ts